<template>
  <div>
    <div>
      <b-form>
        <legend><strong>Profil</strong></legend>
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama Pemohon: *">
              <b-form-input readonly v-model="dataPermohonan.nama_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="NIK Pemohon: *">
              <b-form-input readonly v-model="dataPermohonan.nik_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Email Pemohon: *">
              <b-form-input readonly v-model="dataPermohonan.email_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Alamat Pemohon: *">
              <b-form-input readonly v-model="dataPermohonan.alamat_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nomor Permohonan: *">
              <b-form-input readonly v-model="dataPermohonan.nomor_permohonan" type="text" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="NPWP: *">
              <b-form-input  name="NPWP" readonly :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.NPWP'),
              }" v-model="dataPermohonan.npwp_pemohon" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="NIB: *">
              <b-form-input readonly v-model="dataPermohonan.nib_pemohon" type="text" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="No Proyek: *">
              <b-form-input readonly v-model="dataPermohonan.nomor_proyek" />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Sektor: *">
              <v-select disabled id="default-select" v-model="dataPermohonan.klasifikasi_pemohon"
                :reduce="(klasifikasi) => klasifikasi.nama" label="nama" :options="dataKlasifikasi"
                 name="Klasifikasi Pemohon" :class="{
                  'is-invalid': errors.has('form-1.Klasifikasi Pemohon'),
                }" class="custom-disabled" />
              <span class="text-danger" v-if="errors.has('form-1.Klasifikasi Pemohon')">
                {{ errors.first("form-1.Klasifikasi Pemohon") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="KBLI: *">
              <v-select disabled id="default-select" v-model="dataPermohonan.kbli" :reduce="(kbli) => kbli.kode"
                style="background-color: white !important;" label="kode_deskripsi" :options="dataKBLI" multiple
                 name="KBLI" :class="{ 'is-invalid': errors.has('form-1.KBLI') }" />
              <span class="text-danger" v-if="errors.has('form-1.KBLI')">
                {{ errors.first("form-1.KBLI") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tanggal Permohonan: *">
              <input readonly type="date"  name="Tanggal Permohonan" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Permohonan'),
              }" v-model="dataPermohonan.tanggal_pada_permohonan" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Permohonan')">
                {{ errors.first("form-1.Tanggal Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Jenis Kegiatan: *">
              <b-form-input readonly v-model="dataPermohonan.jenis_kegiatan" type="text" 
                name="Jenis Kegiatan" :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Jenis Kegiatan'),
                }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Kegiatan')">
                {{ errors.first("form-1.Jenis Kegiatan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Lokasi: *">
              <b-form-input readonly type="text"  name="Lokasi" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Lokasi'),
              }" v-model="dataPermohonan.lokasi" />
              <span class="text-danger" v-if="errors.has('form-1.Lokasi')">
                {{ errors.first("form-1.Lokasi") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Jenis Proyek *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.jenis_proyek"
                label="nama" index="nama" :options="dataJenisProyek"  name="Jenis Proyek"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Proyek') }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Proyek')">
                {{ errors.first("form-1.Jenis Proyek") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Risiko *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.risiko"
                label="nama" index="nama" :options="dataRisiko"  name="Risiko"
                :class="{ 'is-invalid': errors.has('form-1.Risiko') }" />
              <span class="text-danger" v-if="errors.has('form-1.Risiko')">
                {{ errors.first("form-1.Risiko") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Skala Usaha *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.skala_usaha"
                label="nama" index="nama" :options="dataSkalaUsaha"  name="Skala Usaha"
                :class="{ 'is-invalid': errors.has('form-1.Skala Usaha') }" />
              <span class="text-danger" v-if="errors.has('form-1.Skala Usaha')">
                {{ errors.first("form-1.Skala Usaha") }}
              </span>
            </b-form-group>
          </b-col>



          <b-col md="6">
            <b-form-group label="Potensi PNBP *">
              <b-form-input readonly  name="Potensi PNBP" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Potensi PNBP'),
              }" v-model="dataPermohonan.potensi_pnbp" type="text" />
              <span class="text-danger" v-if="errors.has('form-1.Potensi PNBP')">
                {{ errors.first("form-1.Potensi PNBP") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tanggal Proses: *">
              <input readonly type="date"  name="Tanggal Proses" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Tanggal Proses'),
              }" v-model="dataPermohonan.tanggal_proses" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Proses')">
                {{ errors.first("form-1.Tanggal Proses") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Reklamasi: *">
              <b-form-select class="custom-disabled" disabled v-model="dataPermohonan.reklamasi" 
                name="Reklamasi" :class="{ 'is-invalid': errors.has('form-1.Reklamasi') }"
                :options="dataReklamasi"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Reklamasi')">
                {{ errors.first("form-1.Reklamasi") }}
              </span>
            </b-form-group>
          </b-col>

          <!-- <b-col md="6">
            <b-form-group label="Prioritas: *">
              <b-form-select
                readonly
                v-model="dataPermohonan.prioritas"
                
                name="Prioritas"
                :class="{ 'is-invalid': errors.has('form-1.Prioritas') }"
                :options="optionsPrioritas"
              ></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Prioritas')">
                {{ errors.first("form-1.Prioritas") }}
              </span>
            </b-form-group>
          </b-col> -->

          <b-col md="6">
            <b-form-group label="PSN: *">
              <b-form-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.psn"
                :options="['PSN', 'Non PSN']"  name="PSN"
                :class="{ 'is-invalid': errors.has('form-1.PSN') }" />
              <span class="text-danger" v-if="errors.has('form-1.PSN')">
                {{ errors.first("form-1.PSN") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="PKPN: *">
              <b-form-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.is_pkpn"
                :options="[{value: true, text: 'PKPN'}, {value: false, text: 'Non PKPN'}]"  name="PKPN"
                :class="{ 'is-invalid': errors.has('form-1.PKPN') }" />
              <span class="text-danger" v-if="errors.has('form-1.PKPN')">
                {{ errors.first("form-1.PKPN") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Bentuk Usaha: *">
              <b-form-select class="custom-disabled" disabled v-model="dataPermohonan.bentuk_usaha"
                 name="Bentuk Usaha" :class="{ 'is-invalid': errors.has('form-1.Bentuk Usaha') }"
                :options="optionsBentukUsaha"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Bentuk Usaha')">
                {{ errors.first("form-1.Bentuk Usaha") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Nilai Investasi: *">
              <currency-input readonly v-model="dataPermohonan.nilai_investasi" name="Nilai Investasi"  />

              <span class="text-danger" v-if="errors.has('form-1.Nilai Investasi')">
                {{ errors.first('form-1.Nilai Investasi') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Serapan Tenaga Kerja: *">
              <b-form-input readonly v-validate="'required'" name="Serapan Tenaga Kerja" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Serapan Tenaga Kerja'),
              }" id="name" type="number" v-model="dataPermohonan.serapan_tenaga_kerja" />
              <span class="text-danger" v-if="errors.has('form-1.Serapan Tenaga Kerja')">
                {{ errors.first("form-1.Serapan Tenaga Kerja") }}
              </span>
            </b-form-group>
          </b-col>
          

          <b-col md="6">
            <b-form-group label="Jenis Permohonan: *">
              <v-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.jenis_pnbp"
                :options="[
                  'Area',
                  'Kabel Bawah Laut',
                  'Pipa Air Bersih / Air Baku',
                  'Pipa Selain Air Bersih / Air Baku',
                ]"  name="Jenis Permohonan" :multiple="true"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
                {{ errors.first("form-1.Jenis Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="dataPermohonan.jenis_pnbp.includes('Area')">
            <b-form-group label="Luas (ha) *">
              <b-form-input readonly min="0" step=".01" type="number" name="Luas" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Luas'),
              }" v-model="dataPermohonan.luas" />
              <span class="text-danger" v-if="errors.has('form-1.Luas')">
                {{ errors.first("form-1.Luas") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
          ">
            <b-form-group label="Panjang Kabel(di dalam Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di dalam Kws. Konservasi)(km)"
                 :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPermohonan.panjang_konservasi_kabel" />
              <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
          ">
            <b-form-group label="Panjang Kabel(di luar Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di luar Kws. Konservasi)(km)"
                 :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPermohonan.panjang_nonkonservasi_kabel" />
              <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Kabel(di luar Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)"  :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPermohonan.panjang_konservasi_pipa_air" />
              <span class="text-danger"
                v-if="errors.has('form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number" name="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)"
                 :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_air" />
              <span class="text-danger"
                v-if="errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)"  :class="{
                  'form-control': true,
                  'is-invalid': errors.has(
                    'form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)'
                  ),
                }" v-model="dataPermohonan.panjang_konservasi_pipa_lain" />
              <span class="text-danger"
                v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="
            dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
          ">
            <b-form-group label="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
              <b-form-input disabled min="0" step=".01" type="number"
                name="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)"  :class="{
                  'form-control': true,
                  'is-invalid': errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)'),
                }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_lain" />
              <span class="text-danger"
                v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)')">
                {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Kategori Permohonan: *" label-for="kategori">
              <b-form-select class="custom-disabled" v-model="dataPermohonan.kategori_permohonan"
                 name="Kategori" :class="{ 'is-invalid': errors.has('form-1.Kategori') }"
                :options="optionsKategori" disabled></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Kategori')">
                {{ errors.first("form-1.Kategori") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label-for="Form Edit" label="Tipe Permohonan: *">
              <b-form-select class="custom-disabled" disabled v-model="dataPermohonan.tipe_permohonan"
                 name="Tipe Permohonan"
                :class="{ 'is-invalid': errors.has('form-1.Tipe Permohonan') }" :options="optionsTipe"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Tipe Permohonan')">
                {{ errors.first("form-1.Tipe Permohonan") }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6" v-if="dataPermohonan.tipe_permohonan == 'Multi KBLI'">
            <b-form-group label-for="Form Edit" label="Tipe Multi KBLI: *">
              <b-form-select class="custom-disabled" disabled v-model="dataPermohonan.tipe_multi_kbli"
                 name="Tipe Multi KBLI"
                :class="{ 'is-invalid': errors.has('form-1.Tipe Multi KBLI') }"
                :options="optionsMultiKBLI"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Tipe Multi KBLI')">
                {{ errors.first("form-1.Tipe Multi KBLI") }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" v-if="dataPermohonan.tipe_multi_kbli == 'Mengikuti'">
            <b-form-group label="Nomor Permohonan Utama: *" label-for="username">
              <b-form-input readonly  name="Nomor Permohonan Utama" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Nomor Permohonan Utama'),
              }" id="name" type="text" v-model="dataPermohonan.nomor_permohonan_utama" />
              <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan Utama')">
                {{ errors.first("form-1.Nomor Permohonan Utama") }}
              </span>

              <span class="text-danger" v-if="status_nomor_error">
                {{ "Nomor Permohonan utama tidak ditemukan, silahkan cek kembali" }}
              </span>
            </b-form-group>
          </b-col>

        </b-row>
      </b-form>
      <div class="row justify-content-between">
        <div class="col-4">
          <div class="text-left">
            <b-button @click="$router.push('/app/perizinan')" variant="danger">Kembali</b-button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-right">
            <b-button @click="nextDokumen()" style="float: right" variant="primary">Selanjutnya <i class="fa fa-caret-right" />
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import vSelect from "vue-select";
import CurrencyInput from "../../../../../components/CurrencyInput/CurrencyInput.vue";
export default {
  data() {
    return {
      baseapi: localStorage.getItem("baseapi"),
      user: JSON.parse(localStorage.getItem("user")),
      optionsPrioritas: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      dataReklamasi: [
        { value: true, text: "Ya" },
        { value: false, text: "Tidak" },
      ],
      optionsBentukUsaha: [
        { value: 'BUMN', text: "BUMN" },
        { value: 'BUMD', text: "BUMD" },
        { value: 'Lainnya', text: "Lainnya" },
      ],
      optionsKategori: [
        { value: 'Permohonan Baru', text: "Permohonan Baru" },
        { value: 'Penambahan KBLI', text: "Penambahan KBLI" },
        { value: 'Notifikasi Izin Lokasi', text: "Notifikasi Izin Lokasi" },
      ],
      optionsTipe: [
        { value: 'Single KBLI', text: "Single KBLI" },
        { value: 'Multi KBLI', text: "Multi KBLI" },
      ],

      optionsMultiKBLI: [
        { value: 'Proses', text: "Proses" },
        { value: 'Mengikuti', text: "Mengikuti" },
      ],
      dataJenisProyek: [],
      dataRisiko: [],
    };
  },
  components: { vSelect, CurrencyInput },
  props: {
    dataPermohonan: {
      type: Object,
      default: () => {
        return {};
      },
    },
    dataKBLI: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataKlasifikasi: {
      type: Array,
      default: () => {
        return [];
      },
    },
    dataSkalaUsaha: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    nextDokumen() {
      this.$emit("nextDokumen");
    },

    //   get jenis proyek
    getJenisProyek() {
      axios
        .get(this.baseapi + "api/jenis_proyek", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataJenisProyek = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
    // get rsiiko
    getRisiko() {
      axios
        .get(this.baseapi + "api/risiko", {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        .then((response) => {
          this.dataRisiko = response.data.data;
        })
        .catch((error) => {
          console.log(error);
          return error;
        });
    },
  },
  mounted() {
    this.getJenisProyek();
    this.getRisiko();
  },
};
</script>